import React, { useContext } from "react";
import Form from "~/common/components/Form";
import Textarea from "~/common/components/textarea";
import Input from "~/common/components/Input";
import InquiryCardGroup from "./InquiryCardGroup";
import { useTranslation } from "react-i18next";
// assets
import "~/assets/sass/pages/applyFormMange/applyFormMange.scss";
import { CategoryIcon } from "~/assets/svg/InterfaceIcon";
import { PlusIcon } from "~/assets/svg/MathIcon";
import { ApplyContext } from "~/pages/applyFormMange/ApplyRegContext";
import { QuestionMarkIcon } from "~/assets/svg/InterfaceIcon";
const InqueryForm = () => {
	const { t } = useTranslation();
	const { applyMangeForm, addCategory, addInquiry, list, isUse, setIsUse } =
		useContext(ApplyContext);

	return (
		<div className="apply-info-form">
			{/* 폼 제목 */}
			<div className="apply-form-head">
				<h3>{t("pages.applyFormMange.inputComponent.applyInquriy.apply-form-head")}</h3>
				<div className="switch-wrap with-tooltip">
					{
						!isUse &&
						<div className="c__tooltip-btn">
							<QuestionMarkIcon/>
							<div className="c__tooltip ">해당 양식은 현재 비활성화 상태로 비공개 상태입니다.<br/>
								양식을 완성하고 활성화 상태로 변경해 주세요.</div>
						</div>
					}
					<label className="switch">
						<input
							type="checkbox"
							checked={isUse}
							onChange={() => setIsUse((prev) => !prev)}
						/>
						<span className="slider round" />
						<span className="slider-label">
							{isUse
								? t("pages.round.RoundReg.Edit.activate")
								: t("pages.round.RoundReg.Edit.deactivate")}
						</span>
					</label>
				</div>
			</div>

			{/* 질문 작성 form */}
			<div className="c__card inquiry-form-title">
				<Form useForm={applyMangeForm}>
					<Input
						name="inquiry"
						placeholder={t(
							"pages.applyFormMange.inputComponent.applyInquriy.inquiryTitle"
						)}
						className="export-label"
						required
					/>
					<Textarea
						className="desc"
						name="inquiryDesc"
						placeholder={t(
							"pages.applyFormMange.inputComponent.applyInquriy.inquiryDesc"
						)}
					/>
				</Form>
			</div>
			<InquiryCardGroup list={list} />
			{/* ----------- 카테고리, 질문폼 생성 버튼 카드----------- */}
			<ul className="inquiry-card-wrap">
				<li className="c__card inquiry-card-generator">
					<button
						type="button"
						className="inquiry-btn-category"
						onClick={() => addCategory()}
					>
						<CategoryIcon />
					</button>
					<button type="button" className="inquiry-btn-plus" onClick={() => addInquiry()}>
						<PlusIcon />
					</button>
				</li>
			</ul>
		</div>
	);
};

export default InqueryForm;
